import { render, staticRenderFns } from "./uuPay.vue?vue&type=template&id=11c6bca9&scoped=true"
import script from "./uuPay.vue?vue&type=script&lang=js"
export * from "./uuPay.vue?vue&type=script&lang=js"
import style0 from "./uuPay.vue?vue&type=style&index=0&id=11c6bca9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c6bca9",
  null
  
)

export default component.exports